import { createGlobalStyle } from "styled-components";

// GlobalStyle을 생성합니다.
export const GlobalStyle = createGlobalStyle`

@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 100;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.otf) format('opentype');}

@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 300;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.otf) format('opentype');}

@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 400;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.otf) format('opentype');}

@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 500;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.otf) format('opentype');}

@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 700;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.otf) format('opentype');}

@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 900;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.otf) format('opentype');}

body, h1, h2, h3, h4, h5, h6, input, textarea, select {
	font-family: 'Noto Sans KR', sans-serif;
}



@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 100;
  font-style: normal;
  font-display: swap;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');

}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 200;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 300;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 400;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 500;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 600;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 700;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 800;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}
@font-face {
  font-family: 'NotoSansKRBold';
  font-weight: 900;
  font-style: normal;
  src: url("styles/fonts/NotoSansKR-Bold.otf") format('truetype');
  font-display: swap;
}

  body{
      font-family: "NotoSansKR";
   }

`;

export const theme = {
  Web_fontSizes: {
    Header1: "32px",
    Header2: "18px",
    Header3: "24px",
    Header4: "20px",
    Body1: "16px",
    Body2: "14px",
    Body3: "14px",
    Body4: "16px",
    Body5: "14px",
    Body6: "16px",
    Caption1: "12px",
    Caption2: "12px",
    Caption3: "12px",
    Caption4: "16px",
  },
  fontWeights: {
    Header1: "700",
    Header2: "600",
    Header3: "400",
    Header4: "700",
    Body1: "600",
    Body2: "500",
    Body3: "600",
    Body4: "400",
    Body5: "500",
    Body6: "600",
    Caption1: "500",
    Caption2: "600",
    Caption3: "700",
    Caption4: "700",
  },
  LineHeight: {
    Header1: "38px",
    Header2: "22px",
    Header3: "28px",
    Header4: "24px",
    Body1: "20px",
    Body2: "18px",
    Body3: "18px",
    Body4: "20px",
    Body5: "20px",
    Body6: "24px",
    Caption1: "16px",
    Caption2: "16px",
    Caption3: "14px",
    Caption4: "20px",
  },
  color: {
    primary: "#00347f",
    secondary: "#00ccaa",
    // blue: "#143551",
    grey: "#3f3f37",
  },
};
